// @flow

import CreateCompanyCustomerEditor from './components/form/CreateCompanyCustomerEditor';
import CreatePersonCustomerEditor from './components/form/CreatePersonCustomerEditor';

export const components = {
    'formLayout:trix-web-plugin-core-customer.listCustomersPage.container.table.action.onAddCompanyCustomer.editor': CreateCompanyCustomerEditor,
    'formLayout:trix-web-plugin-core-customer.listCustomersPage.container.table.action.onAddPersonCustomer.editor': CreatePersonCustomerEditor,
}
